"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetData = exports.setModelData = exports.setModelDataOnReady = exports.setModelDataInitial = void 0;
const constants_1 = require("../constants");
const run_validations_1 = __importDefault(require("./run-validations"));
const type_conversion_1 = require("./type-conversion");
const handleElementInjection = (item, injection) => {
    if (typeof injection === 'string') {
        item[constants_1.MODEL_CONTENTS] = injection;
        return true;
    }
    else if (typeof injection === 'object') {
        Object.entries(injection).forEach(([key, val]) => {
            item[key] = val;
        });
        return true;
    }
    return false;
};
// Initial set-model-data call is populating the model from the server.
// It will be adding values to the model that may or may not have a field attached.
// For any field, we also want to set defaultValue and initialValue
const setModelDataInitial = ({ models, data = {}, elementInjections = {}, }) => {
    models.forEach(model => {
        Object.values(model).forEach(item => {
            handleElementInjection(item, elementInjections[item[constants_1.MODEL_TYPE]]);
            const isField = item.meta && item.meta.fieldValueAttr;
            const isNameValuePair = typeof item.name !== 'undefined';
            if (!isField && !isNameValuePair) {
                return;
            }
            if (!item.meta) {
                item.meta = {};
            }
            const valueAttr = item.meta.fieldValueAttr || 'value';
            const currentValue = item[valueAttr] || '';
            // Has new data to set
            if (item.name && data[item.name] !== undefined) {
                item[valueAttr] = (0, type_conversion_1.equivalentString)(data[item.name]);
            }
            else {
                item[valueAttr] = currentValue;
            }
            (0, run_validations_1.default)(item, { models });
            item.meta.defaultValue = currentValue;
            item.meta.initialValue = item[valueAttr];
        });
    });
};
exports.setModelDataInitial = setModelDataInitial;
const setModelDataOnReady = ({ models }) => {
    models.forEach(model => {
        Object.values(model).forEach(item => {
            const { meta } = item;
            // If it has a defaultValue it is either a field or a name/value pair
            if (!meta || meta.defaultValue === undefined) {
                return;
            }
            item.meta.onReadyValue = item[item.meta.fieldValueAttr || 'value'];
        });
    });
};
exports.setModelDataOnReady = setModelDataOnReady;
const setModelData = ({ models, data = {}, elementInjections = {} }) => models.map((model, index) => {
    const changedModelsById = [];
    Object.entries(model).forEach(([id, item]) => {
        if (handleElementInjection(item, elementInjections[item[constants_1.MODEL_TYPE]])) {
            changedModelsById.push({ id, index });
        }
        if (!item.name || data[item.name] === undefined) {
            return;
        }
        item.value = (0, type_conversion_1.equivalentString)(data[item.name]);
        changedModelsById.push({ id, index });
        (0, run_validations_1.default)(item, { models });
    });
    return changedModelsById;
});
exports.setModelData = setModelData;
const resetData = ({ model, list, metaField = 'onReadyValue', models, }) => {
    Object.values(model).forEach(item => {
        const { meta, name } = item;
        if (!meta ||
            meta[metaField] === undefined ||
            (list && !list.includes(name))) {
            return;
        }
        const valueAttr = meta.fieldValueAttr || 'value';
        item[valueAttr] = meta[metaField];
        (0, run_validations_1.default)(item, { models });
    });
    return model;
};
exports.resetData = resetData;
//# sourceMappingURL=set-data.js.map